import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpService } from 'src/app/shared/services/httpService.service';
import { environment } from 'src/environments/environment.dev';

@Injectable({
  providedIn: 'root'
})
export class OrderReviewService {

  public statusCode: BehaviorSubject<any> = new BehaviorSubject('');

  constructor(
    private http: HttpService,
  ) { }

  updateStatusCode(newStatusCode: any) {
    this.statusCode.next(newStatusCode);
  }

  getAllOrdersUnderReview(data) {
    try {
      let url = "api/orders/review-details";
      let body = {
        "companyId": "UNITYCRM0021",
        "userID": this.http.getUser()?.userID,
        // "orderType": "UCL_SIM",
        ...data
      }
          // Check if customerType exists and is not null → then remove orderStatus
        if (data?.customerType != null) {
          delete body.orderStatus;
        }
      // Add onlyPending:1 for pending document review
      if (data && data.orderStatus === 'RO_CARD_PENDING_DOCUMENT_REVIEW') {
        body.onlyPending = 1;
      }
      
      return this.http.get(url, body, true).toPromise()
    } catch (err) {
      throw Error(err)
    }
  }

  getAllOrdersUnderReviewBySource(source, data) {
    try {
      let url = "api/orders/review/source/" + source;
      let body = {
        "companyId": "UNITYCRM0021",
        "userID": this.http.getUser()?.userID,
        ...data
      }
      return this.http.get(url, body, true).toPromise()
    } catch (err) {
      throw Error(err)
    }
  }

  getAllOrdersUnderReviewByStatus(data, status) {
    try {
      let url = "api/orders/review/status/" + status;
      let body = {
        "companyId": "UNITYCRM0021",
        "userID": this.http.getUser()?.userID,
        ...data
      }
      return this.http.get(url, body, true).toPromise()
    } catch (err) {
      throw Error(err)
    }
  }

  advanceOrderSearch(data) {
    try {
      let url = "api/Search/Advance";
      const { fromDate, toDate, ...filteredData } = data || {};
      let body = {
        "companyId": "UNITYCRM0021",
        "userID": this.http.getUser()?.userID,
        ...filteredData
      }
      return this.http.get(url, body, true).toPromise()
    } catch (err) {
      throw Error(err)
    }
  }

  getStatusCount(data) {
    try {
      let url = "api/orders/status-counts";
      let body = {
        "companyId": "UNITYCRM0021",
        "userID": this.http.getUser()?.userID,
        // "orderType": "UCL_SIM",
        // "onlyPending":1,
        ...data
      }
      return this.http.get(url, body, true).toPromise()
    } catch (err) {
      throw Error(err)
    }
  }

  getOrderById(id) {
    try {
      let url = "api/getOrder/" + id;
      // let url = "api/getOrder/198";
      let body = {
        "companyId": "UNITYCRM0021",
        "userID": this.http.getUser()?.userID,
      }
      return this.http.get(url, body, true).toPromise()
    } catch (err) {
      throw Error(err)
    }
  }

  getNladHistroy(id, body) {
    try {
      let url = "api/nladHistory/" + id
      return this.http.get(url, body).toPromise()
    } catch (err) {
      throw Error(err)
    }
  }

  async getSourceOrderReview() {
    try {
      let url = "api/system/resource-permissions"
      let body = {
        "companyId": "UNITYCRM0021",
        "userID": this.http.getUser()?.userID,
        "resourceType[]": [
          "TABS_REVIEW_ORDER",
          // "ACTION_BUTTON_REVIEW_ORDER"
        ]
      }
      return this.http.get(url, body, true).toPromise()
    } catch (err) {
      throw Error(err)
    }
  }

  async getOrderCards() {
    try {
      let url = "api/system/resource-permissions"
      let body = {
        "companyId": "UNITYCRM0021",
        "userID": this.http.getUser()?.userID,
        "resourceType[]": [
          "RO_DASHBOARD_CARD",
        ]
      }
      return this.http.get(url, body, true).toPromise()
    } catch (err) {
      throw Error(err)
    }
  }


  async getButtonOrderReview() {
    try {
      let url = "api/system/resource-permissions"
      let body = {
        "companyId": "UNITYCRM0021",
        "userID": this.http.getUser()?.userID,
        "resourceType[]": [
          "ACTION_BUTTON_REVIEW_ORDER"
        ]
      }
      return this.http.get(url, body, true).toPromise()
    } catch (err) {
      throw Error(err)
    }

  }

  advanceSearch(data) {
    try {
      let url = "api/system/resource-permissions"
      let body = {
        "companyId": "UNITYCRM0021",
        "userID": this.http.getUser()?.userID,
        ...data
      }
      return this.http.get(url, body, true).toPromise()
    } catch (err) {
      throw Error(err)
    }
  }

  async getCustomerDocuments(enrollmentId?: string, customerId?: string): Promise<any> {
    try {
      // Don't make API call if both IDs are missing
      if (!enrollmentId && !customerId) {
        return null;
      }

      const payload: any = {
        "companyId": "UNITYCRM0021",
        "userID": this.http.getUser()?.userID,
      };
      
      // First try with enrollmentId if available
      if (enrollmentId) {
        payload.enrollmentId = enrollmentId;
      } else if (customerId) {
        // If no enrollmentId, use customerId
        payload.CustomerId = customerId;
      }

      const response: any = await this.http
        .get('api/orders/customerDocuments', payload, false)
        .toPromise();

      return response;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Get UCL Enrollments for a customer
   * @param params Optional parameters: searchTerm, status, startDate, endDate
   * @returns Promise with enrollment data
   */
  async getUCLEnrollments(params: {
    searchTerm?: string,
    status?: string[],
    startDate?: string,
    endDate?: string
  } = {}): Promise<any> {
    try {
      const url = "api/Customer/getUCLEnrollments";
      
      // Create query parameters - we need to handle arrays specially
      const queryParams: any = {
        "companyId": "UNITYCRM0021",
        "userID": this.http.getUser()?.userID
      };
      
      // Add search term if provided
      if (params.searchTerm) {
        queryParams.searchTerm = params.searchTerm;
      }
      
      // // Handle status array if provided
      // if (params.status && params.status.length > 0) {
      //   // Add each status as a separate array parameter
      //   params.status.forEach((status, index) => {
      //     queryParams[`status[${index}]`] = status;
      //   });
      // }
      
      // Add date range if provided
      if (params.startDate) {
        queryParams.startDate = params.startDate;
      }
      
      if (params.endDate) {
        queryParams.endDate = params.endDate;
      }
      
      return this.http.get(url, queryParams, true).toPromise();
    } catch (error) {
      console.error('Error in getUCLEnrollments:', error);
      throw error;
    }
  }

  /**
   * Get pending documents for a specific enrollment ID
   * @param enrollmentId The ID of the enrollment to fetch pending documents for
   * @returns Promise with pending documents data
   */
  async getPendingDocuments(enrollmentId: string | number): Promise<any> {
    try {
      if (!enrollmentId) {
        throw new Error('Enrollment ID is required');
      }

      const url = `api/Customer/getPendingDocuments/${enrollmentId}`;
      
      const queryParams = {
        "companyId": "UNITYCRM0021",
        "userID": this.http.getUser()?.userID
      };
      
      return this.http.get(url, queryParams, true).toPromise();
    } catch (error) {
      console.error('Error in getPendingDocuments:', error);
      throw error;
    }
  }

  /**
   * Get available order types from the API
   * @returns Promise with order types data
   */
  async getOrderTypes(): Promise<any> {
    try {
      const url = "api/orders/orderTypes";
      const body = {
        "companyId": "UNITYCRM0021",
        "userID": this.http.getUser()?.userID
      };
      
      return this.http.get(url, body, true).toPromise();
    } catch (error) {
      console.error('Error fetching order types:', error);
      throw error;
    }
  }
    /**
   * Get program requirements from the API
   * @param type Program type (e.g., 'UCL')
   * @param programId Program ID to fetch requirements for
   * @returns Promise with program requirements data
   */
    async getprogramRequirements(programId?: string,type?: string ): Promise<any> {
      try {
        const url = "api/californiaLifeline/registration/get-program-requirements";
        const body = {
          "companyId": "UNITYCRM0021",
          "userID": this.http.getUser()?.userID,
          "programId": programId || ""
          //  "programId": '37'
        };
        
        console.log('Fetching program requirements with:', body);
        return this.http.get(url, body, true).toPromise();
      } catch (error) {
        console.error('Error fetching program requirements:', error);
        throw error;
      }
    }

  /**
   * Upload document to the server
   * @param data Upload data (file, programId, enrollmentId, etc.)
   * @returns Promise with upload response
   */
  async uploadDocument(data: FormData): Promise<any> {
    try {
      const url = "api/orders/uploadDocument";
      
      // Only add missing required fields, don't override existing values
      if (!data.has('companyId')) {
        data.append('companyId', 'UNITYCRM0021');
      }
      
      if (!data.has('userId')) {
        data.append('userId', `${this.http.getUser()?.userID}`);
      }
      
      // Don't add default programId or enrollmentId if they're already in the FormData
      // They should be provided dynamically by the component
      
      // Log FormData content for debugging
      console.log('Uploading document with FormData:');
      try {
        for(let pair of (data as any).entries()) {
          console.log(pair[0] + ': ' + pair[1]);
        }
      } catch (e) {
        console.error('Error logging FormData:', e);
      }
      
      // Use direct FormData without wrapping it in an object
      // This prevents the HTTP service from trying to merge it with default values
      return this.http.post(url, data, true).toPromise();
    } catch (error) {
      console.error('Error uploading document:', error);
      throw error;
    }
  }

  /**
   * Remove document from the server
   * @param documentId ID of the document to remove
   * @param orderStatusId Status ID of the order
   * @param remarks Optional remarks for the removal
   * @returns Promise with removal response
   */
  async removeDocument(documentId: string, orderStatusId?: number, remarks?: string): Promise<any> {
    try {
      const url = `api/orders/removeDocument/${documentId}`;
      
      const body = {
        "companyId": "UNITYCRM0021",
        "userID": this.http.getUser()?.userID,
        "orderStatusId": orderStatusId,
        "remarks": remarks || "" // Optional remarks
      };
      
      return this.http.put(url, body, true).toPromise();
    } catch (error) {
      console.error('Error removing document:', error);
      throw error;
    }
  }

  /**
   * Update order status (approve/reject)
   * @param orderId ID of the order to update
   * @param orderStatusCode Status code to set (e.g. 'RO_CARD_PENDING_REVIEW_ORDERS' for approve)
   * @param remarks Optional remarks for the status change
   * @param approveForcefully Optional flag to forcefully approve (1 to enable)
   * @returns Promise with update response
   */
  async updateOrderStatus(orderId: string, orderStatusCode: string, remarks?: string, approveForcefully?: number): Promise<any> {
    try {
      const url = `api/orders/updateOrder/${orderId}`;
      
      const body: any = {
        "companyId": "UNITYCRM0021",
        "userID": this.http.getUser()?.userID,
        "orderStatusCode": orderStatusCode,
        "remarks": remarks || "" // Optional remarks
      };
      
      // Add approveForcefully flag if specified
      if (approveForcefully !== undefined) {
        body.approveForcefully = approveForcefully;
      }
      
      console.log(`Updating order ${orderId} with status ${orderStatusCode}, remarks: ${remarks || 'none'}, forcefully: ${approveForcefully ? 'yes' : 'no'}`);
      
      return this.http.put(url, body, true).toPromise();
    } catch (error) {
      console.error('Error updating order status:', error);
      throw error;
    }
  }

  /**
   * Approve a document
   * @param documentId Document ID to approve
   * @returns Promise of the response
   */
  async approveDocument(documentId: string): Promise<any> {
    try {
      const url = `api/document/approve/${documentId}`;
      const body = {
        "companyId": "UNITYCRM0021",
        "userID": this.http.getUser()?.userID
      };
      return this.http.put(url, body, true).toPromise();
    } catch (error) {
      console.error('Error approving document:', error);
      throw error;
    }
  }

  /**
   * Approve a document using the new API endpoint
   * @param documentId Document ID to approve
   * @returns Promise of the response
   */
  async approveDocumentNew(documentId: string): Promise<any> {
    try {
      const url = `api/orders/approveDocument/${documentId}`;
      const body = {
        "companyId": "UNITYCRM0021", 
        "userID": this.http.getUser()?.userID
      };
      return this.http.put(url, body, true).toPromise();
    } catch (error) {
      console.error('Error approving document with new API:', error);
      throw error;
    }
  }

  /**
   * Reject a document
   * @param documentId Document ID to reject
   * @returns Promise of the response
   */
  async rejectDocument(documentId: string): Promise<any> {
    try {
      const url = `api/document/reject/${documentId}`;
      const body = {
        "companyId": "UNITYCRM0021",
        "userID": this.http.getUser()?.userID
      };
      return this.http.put(url, body, true).toPromise();
    } catch (error) {
      console.error('Error rejecting document:', error);
      throw error;
    }
  }

   /**
   * Reject a document
   * @param documentId Document ID to reject
   * @returns Promise of the response
   */
   async getCheckLists(): Promise<any> {
    try {
      const url = "api/orders/checklist";
      const body = {
        "companyId": "UNITYCRM0021",
        "userID": this.http.getUser()?.userID
      };
      return this.http.get(url, body, true).toPromise();
    } catch (err) {
      throw Error(err);
    }
  }

  /**
   * Get minimal profile data for a customer
   * @param customerId Customer ID to fetch profile data for
   * @returns Promise with customer profile data
   */
  async getMinimalProfileData(customerId: string | number): Promise<any> {
    try {
      const url = "api/Customer/getMinimalProfileData";
      const body = {
        "companyId": "UNITYCRM0021",
        "userID": this.http.getUser()?.userID,
        "CustomerId": customerId
      };
      return this.http.get(url, body, true).toPromise();
    } catch (err) {
      throw Error(err);
    }
  }

  /**
   * Perform DMD check for a customer
   * @param payload DMD check payload containing customer and subscriber information
   * @returns Promise with DMD check result
   */
  async dmdCheck(payload: any): Promise<any> {
    try {
      const url = "api/Customer/CheckCustomerDMD";
      const body = {
        CustomerId:payload?.CustomerId,
        "companyId": "UNITYCRM0021",
        "userID": this.http.getUser()?.userID
      };
      return this.http.get(url, body, true).toPromise();
    } catch (err) {
      throw Error(err);
    }
  }

   /**
   * Get minimal profile data for a customer
   * @param customerId Customer ID to fetch profile data for
   * @returns Promise with customer profile data
   */
   async orderActivitytimeline(customerId: string | number,orderId: string | number): Promise<any> {
    try {
      const url = "api/orders/orderActivityLogTimeline";
      const body = {
        "companyId": "UNITYCRM0021",
        "userID": this.http.getUser()?.userID,
        "CustomerId": customerId,
        "orderId": orderId
      };
      console.log( 'paylod',body);
      return this.http.get(url, body, true).toPromise();
    } catch (err) {
      throw Error(err);
    }
  }



  /**
   * Validate address using USPS validation
   * @param payload Address data to validate
   * @returns Promise with validation result
   */
  async validateAddress(payload: any): Promise<any> {
    try {
      const url = "api/Customer/validateAddress";
      return this.http.post(url, payload, true).toPromise();
    } catch (err) {
      throw Error(err);
    }
  }

  /**
   * Manually validate address (force validation)
   * @param payload Address data with force override flag
   * @returns Promise with validation result
   */
  async manuallyValidateAddress(payload: any): Promise<any> {
    try {
      const url = "api/orders/manuallyValidateAddress";
      return this.http.post(url, payload, true).toPromise();
    } catch (err) {
      throw Error(err);
    }
  }

  /**
   * Check address history after address update
   * @param payload Service address data
   * @returns Promise with address check result
   */
  async checkAddressHistory(payload: any): Promise<any> {
    try {
      const url = "api/orders/checkAddressHistory";
      return this.http.post(url, payload, true).toPromise();
    } catch (err) {
      throw Error(err);
    }
  }

    /**
   * get customer address 
   * @param payload registrationId
   * @returns Promise with customer address result
   */
    async getCustomerAddress(payload: any): Promise<any> {
      try {
        const url = "api/orders/getCustomerAddress";
        return this.http.get(url, payload, true).toPromise();
      } catch (err) {
        throw Error(err);
      }
    }

    /**
   * Update address using USPS validated data
   * @param payload Address data with validated information
   * @returns Promise with update result
   */
    async checkUspsUpdateAddress(payload: any): Promise<any> {
      try {
        const url = "api/orders/checkUspsUpdateAddress";
        return this.http.post(url, payload, true).toPromise();
      } catch (err) {
        throw Error(err);
      }
    }

    storeViewer(orderId: string) {
      try {
        const url = `api/orders/storeViewer/${orderId}`;
        const body = {
          "companyId": "UNITYCRM0021",
          "userID": this.http.getUser()?.userID,
        };
        return this.http.post(url, body, true);
      } catch (err) {
        throw Error(err);
      }
    }
  
    /**
     * Get active viewers for an order
     */
    getViewers(orderId: string) {
      try {
        const url = `api/orders/getViewers/${orderId}`;
        const body = {
          "companyId": "UNITYCRM0021",
          "userID": this.http.getUser()?.userID,
        };
        return this.http.get(url, body, true);
      } catch (err) {
        throw Error(err);
      }
    }
  
    /**
     * Remove current user as viewer for an order
     */
    destroyViewer(orderId: string) {
      try {
        const url = `api/orders/destroyViewer/${orderId}`;
        const body = {
          "companyId": "UNITYCRM0021",
          "userID": this.http.getUser()?.userID,
        };
        return this.http.delete(url, body, true);
      } catch (err) {
        throw Error(err);
      }
    }

        /**
     * Get customer type for an order
     */
        getCustomerTypes() {
          try {
            const url = `api/orders/transferTypes`;
            const body = {
              "companyId": "UNITYCRM0021",
              "userID": this.http.getUser()?.userID,
            };
            return this.http.get(url, body, true).toPromise();
          } catch (err) {
            throw Error(err);
          }
        }
}

